import { Flex, Icon, IconProps, Tooltip } from "@chakra-ui/react";
import React from "react";
import { IconType } from "react-icons/lib";

import { Button } from "../../../components";
import { CallNoteType } from "../../graphql";
import {
  CONTROL_ACTIVE_BG,
  CONTROL_HOVER_BG,
  IconClip,
  IconFlag,
  IconNote,
  IconStar,
} from "./theme";

export type ActionBarV2Props = {
  isVideoVisible: boolean;
  onCreateClipClick?(): void;
  openNote(type: CallNoteType): () => void;
};

const ActionBarButton: React.FC<{
  tooltip: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  mouseOverColor?: string;
  icon: IconType | ((props: IconProps) => JSX.Element);
  disallowWider?: boolean;
}> = ({ tooltip, onClick, icon, mouseOverColor, disallowWider }) => {
  return (
    <Tooltip label={tooltip}>
      <Button
        variant="ghost"
        color="white"
        borderRadius="full"
        w="8"
        h="8"
        minW="8"
        p="0"
        display="flex"
        alignItems="center"
        justifyContent="center"
        _active={{
          bg: CONTROL_ACTIVE_BG,
          color: mouseOverColor ? `${mouseOverColor}.300` : "white",
        }}
        _hover={{
          bg: CONTROL_HOVER_BG,
          color: mouseOverColor ? `${mouseOverColor}.300` : "white",
        }}
        onClick={onClick}
      >
        <Icon
          as={icon}
          boxSize="4"
          sx={
            !disallowWider
              ? {
                  "& path": {
                    stroke: "white",
                    strokeWidth: "48.5px",
                  },
                }
              : {}
          }
        />
      </Button>
    </Tooltip>
  );
};

const ActionBarV2: React.FC<ActionBarV2Props> = ({
  isVideoVisible,
  onCreateClipClick,
  openNote,
}) => {
  return (
    <Flex
      direction={isVideoVisible ? "column" : "row"}
      borderRadius="3xl"
      py="1"
      px="1"
      bg={isVideoVisible ? "blackAlpha.600" : "transparent"}
      data-tour-id="ip2-action-bar"
    >
      <ActionBarButton
        tooltip="Noteworthy moment"
        onClick={openNote(CallNoteType.Star)}
        icon={IconStar}
        mouseOverColor="yellow"
      />
      <ActionBarButton
        icon={IconFlag}
        tooltip="Potential red flag"
        onClick={openNote(CallNoteType.Flag)}
        mouseOverColor="red"
      />
      <ActionBarButton
        icon={IconNote}
        tooltip="Add note"
        onClick={openNote(CallNoteType.Note)}
      />
      {onCreateClipClick !== undefined && (
        <ActionBarButton
          tooltip="Create clip"
          onClick={onCreateClipClick}
          icon={IconClip}
          disallowWider
        />
      )}
    </Flex>
  );
};

export default ActionBarV2;
